import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';
import { FaqItemType } from 'components/Faqs/types';
import { FaqItem } from 'components/Faqs/FaqItem';
import styles from 'components/Faqs/Faqs.module.scss';

const cn = classNames.bind(styles);

interface FaqsProps {
  faqsData: FaqItemType[];
  faqsListClassNames?: {
    list?: string;
  };
  faqItemClassNames?: {
    container?: string;
    label?: string;
    heading?: string;
    iconContainer?: string;
    answerContainer?: string;
    answerText?: string;
  };
};

const Faqs: FC<FaqsProps> = ({ faqsData, faqsListClassNames, faqItemClassNames }): ReactElement => {
  const faqItemsElements = faqsData.map((item: FaqItemType) => {
    return (
      <FaqItem
        key={item.id}
        id={item.id}
        question={item.question}
        answer={item.answer}
        customClassNames={faqItemClassNames}
      />
    );
  });

  return (
    <ul className={cn('faqs', faqsListClassNames?.list)}>
      {faqItemsElements}
    </ul>
  );
};

export { Faqs };